import * as React from "react"
/**
 * Pulled from
 *    - https://github.com/floating-ui/floating-ui/blob/master/packages/react/src/hooks/useMergeRefs.ts
 */
const useMergeRefs = <T>(
  refs: (React.Ref<T> | null | undefined)[]
): React.RefCallback<T> | null => {
  return React.useMemo(() => {
    if (refs.every((ref) => ref === null || ref === undefined)) {
      return null
    }
    return (value) => {
      refs.forEach((ref) => {
        if (typeof ref === "function") {
          ref(value)
        } else if (ref !== null && ref !== undefined) {
          // eslint-disable-next-line no-param-reassign
          ;(ref as React.RefObject<T | null>).current = value
        }
      })
    }
    // Tracked by MYVC-38774
    // oxlint-disable-next-line unicorn/no-abusive-eslint-disable
    // oxlint-disable-next-line
  }, refs)
}

export default useMergeRefs
